import { render, staticRenderFns } from "./international-bancard.vue?vue&type=template&id=44c25e5e"
import script from "./international-bancard.vue?vue&type=script&lang=js"
export * from "./international-bancard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports